import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class PlainDef {
  key?: string = uuid()
  type: 'plain' = 'plain'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: PlainOptions = new PlainOptions()
  rules?: Rule[]
}

export class PlainOptions {
  defaultValue?: string
  disabled?: DisabledType = false
  labelWidth?: string | number
  color?: 'regular' | 'secondary' | 'heading' | 'primary' | 'success' | 'info' | 'warning' | 'danger' = 'secondary'
  ellipsis?: boolean = true
  copiable?: boolean = true
  formatter?: (value: string, model: string, form: Record<string | number, any>) => string
}
